import { render, staticRenderFns } from "./ProjectDetailsTab.vue?vue&type=template&id=7e66d5f1&"
import script from "./ProjectDetailsTab.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports